import React, { Component } from "react";
import { Select } from "antd";
import { cmmsPost } from "../cmmsComun";

// Select de contratos CMMS (opcionalmente de un cliente). value / onChange(id, contrato).
class SelectContratoCMMS extends Component {
    state = { contratos: [], cargando: false };

    componentDidMount() {
        this.cargar();
    }

    componentDidUpdate(prev) {
        if (prev.clienteId !== this.props.clienteId) this.cargar();
    }

    cargar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "opcionesContratosCMMS", { clienteId: this.props.clienteId || null, soloActivos: !!this.props.soloActivos });
            this.setState({ contratos: res.data.success === 2 ? res.data.contratos : [] });
        } catch (error) {
            console.log(error);
        } finally {
            this.setState({ cargando: false });
        }
    };

    render() {
        const { value, onChange, placeholder, style, disabled, allowClear = true } = this.props;
        return (
            <Select
                showSearch
                allowClear={allowClear}
                disabled={disabled}
                loading={this.state.cargando}
                placeholder={placeholder || "Todos los contratos"}
                optionFilterProp="label"
                style={{ width: "100%", ...style }}
                value={value || undefined}
                onChange={(id) => onChange?.(id || null, this.state.contratos.find((c) => c._id === id) || null)}
                options={this.state.contratos.map((c) => ({
                    value: c._id,
                    label: `${c.nombre}${this.props.clienteId ? "" : ` · ${c.clienteNombre}`}${c.estatusClave === "vigente" ? "" : ` (${c.estatusNombre})`}`,
                }))}
            />
        );
    }
}

export default SelectContratoCMMS;
